import React from 'react';

export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Set Up Your School',
      description: 'Configure administrators, teachers, classes, subject schedules, and academic term structures in minutes.',
      icon: '⚙️',
      color: 'from-blue-500 to-indigo-500',
    },
    {
      number: '02',
      title: 'Manage Daily Operations',
      description: 'Teachers take morning attendance, create auto-graded MCQ quizzes, post assignments, and communicate with parents.',
      icon: '📋',
      color: 'from-purple-500 to-pink-500',
    },
    {
      number: '03',
      title: 'Track Performance & Reports',
      description: 'Review admin analytics, compute weighted grade book scores, and export official PDF student report cards.',
      icon: '📊',
      color: 'from-emerald-500 to-teal-500',
    },
  ];

  return (
    <section id="how-it-works" className="py-24 bg-slate-950/90 relative overflow-hidden border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="text-xs font-bold uppercase tracking-widest text-blue-400 mb-3">
            STREAMLINED WORKFLOW
          </div>
          <h2 className="font-serif text-3xl sm:text-5xl font-extrabold text-white tracking-tight mb-4">
            How EduPortal Works
          </h2>
          <p className="text-slate-400 text-base sm:text-lg">
            From initial administrative setup to daily classroom management and term reporting.
          </p>
        </div>

        {/* Steps Grid (Horizontal Desktop / Vertical Mobile) */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Connecting Line Desktop */}
          <div className="hidden md:block absolute top-1/2 left-1/6 right-1/6 h-0.5 bg-gradient-to-r from-blue-500/50 via-purple-500/50 to-emerald-500/50 -translate-y-8 pointer-events-none z-0" />

          {steps.map((step, idx) => (
            <div
              key={idx}
              className="relative z-10 bg-slate-900/80 border border-white/10 rounded-3xl p-8 text-center flex flex-col items-center justify-between group hover:border-white/20 transition-all duration-300 hover:-translate-y-1 shadow-xl"
            >
              <div className="w-full flex justify-between items-center mb-6">
                <span className="text-4xl font-black bg-gradient-to-br from-slate-200 to-slate-500 bg-clip-text text-transparent">
                  {step.number}
                </span>
                <span className="text-2xl p-3 bg-white/5 border border-white/10 rounded-2xl">
                  {step.icon}
                </span>
              </div>

              <div className="space-y-3 mb-6">
                <h3 className="text-xl font-bold text-white group-hover:text-blue-300 transition-colors">
                  {step.title}
                </h3>
                <p className="text-slate-400 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>

              <div className={`w-full h-1.5 rounded-full bg-gradient-to-r ${step.color} opacity-80 group-hover:opacity-100 transition-opacity`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
